import { format } from 'date-fns';
import { Guide } from 'types/guide';

export const START_HOUR = 8;
export const END_HOUR = 21;
export const HOUR_HEIGHT = 42;
export const DAY_COUNT = 7;

export const getStatusLabel = (status?: string) => {
  const labels: Record<string, string> = {
    pending: 'Pendente',
    paid: 'Pago',
    open: 'Aberta',
    finished: 'Concluída',
    completed: 'Concluída',
    canceled: 'Cancelada',
    deleted: 'Cancelada',
    no_show: 'Faltou',
  };

  return labels[status || ''] || 'Em andamento';
};

export const getTone = (guide: Guide) => {
  const tones = ['green', 'yellow', 'blue', 'pink', 'purple'];

  if (guide.status === 'deleted' || guide.status === 'canceled') return 'pink';
  if (guide.status === 'finished' || guide.status === 'completed' || guide.status === 'paid') return 'green';
  if (guide.status === 'pending' || guide.status === 'no_show') return 'yellow';

  return tones[guide.id % tones.length];
};

export const getGuideDate = (guide: Guide) => new Date(guide.appointment_date);

export const getGuideTime = (appointmentDate?: string | Date) => {
  if (!appointmentDate) return '--:--';

  return format(new Date(appointmentDate), 'HH:mm');
};

export const getSlotKey = (guide: Guide) => format(getGuideDate(guide), 'yyyy-MM-dd HH:mm');

export const getSlotLayout = (guide: Guide, dayGuides: Guide[]) => {
  const sameSlotGuides = dayGuides.filter(dayGuide => getSlotKey(dayGuide) === getSlotKey(guide));
  const slotIndex = sameSlotGuides.findIndex(dayGuide => dayGuide.id === guide.id);
  const slotCount = Math.max(sameSlotGuides.length, 1);

  return {
    slotCount,
    slotIndex: Math.max(slotIndex, 0),
  };
};

export const getGuidePosition = (guide: Guide) => {
  const date = getGuideDate(guide);
  const minutes = date.getHours() * 60 + date.getMinutes();
  const startMinutes = START_HOUR * 60;
  const endMinutes = END_HOUR * 60;
  const visibleMinutes = (END_HOUR - START_HOUR) * 60;
  const clampedMinutes = Math.min(Math.max(minutes, startMinutes), endMinutes - 45);
  const offset = clampedMinutes - startMinutes;

  return {
    top: (offset / visibleMinutes) * ((END_HOUR - START_HOUR) * HOUR_HEIGHT),
    height: HOUR_HEIGHT - 8,
  };
};

export const getInitials = (name?: string) => {
  if (!name) return 'UP';

  return name
    .split(' ')
    .slice(0, 2)
    .map(item => item[0])
    .join('')
    .toUpperCase();
};
